
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-24 15:11:24
-->
<template>
  <el-drawer
    :title="ruleForm.id ? '编辑友链分组' : '添加友链分组'"
    :visible.sync="visibleTwo"
    @closed="closeTwo"
    :size="width<=720?'90%':'500px'"
    :with-header="true"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      class="demo-ruleForm"
    >
      <el-form-item label="分组名称" prop="groupName">
        <el-input
          v-model="ruleForm.groupName"
          placeholder="请输入分组名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sort">
        <el-input v-model="ruleForm.sort" placeholder="请输入排序"></el-input>
        <div style="color: #ccc; font-size: 12px">
          数值越小越靠前，将影响网站中友链分类的显示顺序
        </div>
      </el-form-item>
      <el-form-item label="是否显示" prop="flagRequired">
        <div class="status">
          <el-radio v-model="ruleForm.isShow" :label="true">是</el-radio>
          <el-radio v-model="ruleForm.isShow" :label="false">否</el-radio>
        </div>
        <div style="color: #ccc; font-size: 12px">
          若设置不显示，网站中友链用下一个分类代替显示
        </div>
      </el-form-item>
      <el-form-item class="bottom">
        <div class="form-bottom">
          <el-button style="padding: 10px 24px" size="small" @click="closeTwo"
            >取消</el-button
          >
          <el-button
            style="padding: 10px 24px"
            size="small"
            :loading="loadingBtn"
            type="primary"
            @click="saveVariable"
            >保存</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { add, update } from "./custom_variables.js";
export default {
  data() {
    return {
      loadingBtn:false,
      visibleTwo:false,
      width:'',
      ruleForm: {
        groupName: "",
        isShow: true,
        sort: "1",
        siteId: sessionStorage.getItem("siteId"),
      },
      rules: {
        groupName: [
          { required: true, message: "请输入分组名称", trigger: "blur" },
        ],
        sort: [{ required: true, message: "排序", trigger: "blur" }],
        isShow: [{ required: true, message: "是否显示", trigger: "blur" }],
      },
      codeData:[],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editVariableId: {
      type: Number,
      default: null,
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  watch: {
    visible() {
       this.visibleTwo = this.visible;
        this.width  = document.documentElement.clientWidth;
        window.onresize = () => {
          return (() => {
             this.width  = document.documentElement.clientWidth;
          })();
        };
      if (this.item.id) {
        this.ruleForm.groupName = this.item.groupName;
        this.ruleForm.isShow = this.item.isShow;
        this.ruleForm.sort = this.item.sort;
        this.ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
        this.ruleForm.id = this.item.id;
      } else {
        this.ruleForm = {
          groupName: "",
          isShow: true,
          sort: "1",
          siteId: sessionStorage.getItem("siteId"),
        };
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
      this.$refs.ruleForm.clearValidate();
    },
    closeTwo(){
      this.$emit("closeTwo");
      this.$refs.ruleForm.clearValidate();
    },
    saveVariable() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
           this.loadingBtn = true;
          if (this.ruleForm.id) {
            update(this.ruleForm).then((res) => {
              if (res.code == 0) {
                this.close();
              }
              this.loadingBtn = false;
            });
            
          } else {
            add(this.ruleForm).then((res) => {
              if (res.code == 0) {
                this.close();
              }
               this.loadingBtn = false;
            });
            
          }
        } else {
          //就像用户提示发生错误的消息
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.el-button--primary {
  background: #176de6;
}
</style>